import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../hooks/hooks";
import Table from "../../../../common/components/table";
import PageLoader from "../../../../components/PageLoader";
import { zone } from "../../../../redux/zone/action";
import { selectZoneListItems } from "../../../../redux/zone/selector";

const ManagementNexusZones = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const itemsData = useSelector(selectZoneListItems)
  const [columnDefs, setColumnDefs] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'Name', headerName: 'Name', sortable: true, filter: true },
      { field: 'Citycode', headerName: 'CityCode' },
      { field: 'Code', headerName: 'Code' },
      { field: 'Description', headerName: 'Description' },
    ]);
  }

  const handleAdd = () => {
    navigate(`${0}`)
  }

  const handleEdit = (data: any) => {
    navigate(`${data?.GlobalNexusZoneId}`)
  }

  const handleDelete = (data: any) => {
    dispatch(zone.delete({
      url: `https://edgegateway.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/nexus_management/global_nexus_zones/delete`,
      entity: 'NexusZones',
      jsonData: {
          "Context": {},
        Records: [
          {
              Id: data?.GlobalNexusZoneId
          }
        ]
      }
    })).then(() => {
      dispatch(zone.list({
        url: `https://edgegateway.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/nexus_management/global_nexus_zones/fetch`,
        entity: 'NexusZones',
        jsonData: {
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "Id",
          "SortOrder": "desc",
        }
      }));
    });
  }

  const additionButtons: any = [
    {
      name: 'Add NexusZones',
      callback: () => handleAdd(),
    }
  ];

  const fetchNexusARecordTypeList = () => {
    dispatch(zone.list({
      url: `https://edgegateway.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/nexus_management/global_nexus_zones/fetch`,
      entity: 'NexusZones',
      jsonData: {

        "Context": {
              },
  "Records": [
    {},
  ],
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",

      }
    }))
  }

  useEffect(() => {
    createColumnDefs()
    fetchNexusARecordTypeList()
  }, [pageData, pageSize])

  return (
    <>
      {itemsData?.isLoading ? <PageLoader /> :
        <Table columnData={columnDefs} rowData={itemsData?.result?.items} setPageData={setPageData} setPageSize={setPageSize}
          paginationData={itemsData?.result?.pagination} onEdit={handleEdit} onDelete={handleDelete}
          additionButtons={additionButtons} headingName="Nexus-Zone" />
      }
    </>
  );
};

export default ManagementNexusZones;




function selectNexusZonesListItems(state: unknown): unknown {
  throw new Error("Function not implemented.");
}

